function humanize(v) {
    const s = v.replace(/_/g, ' ').trim().toLowerCase();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '—';
}
function lookup(map) {
    return (v) => {
        var _a;
        const key = String(v !== null && v !== void 0 ? v : '').trim().toLowerCase();
        if (!key)
            return { label: '—', tone: 'neutral' };
        return (_a = map[key]) !== null && _a !== void 0 ? _a : { label: humanize(key), tone: 'neutral' };
    };
}
export const shiftStatus = lookup({
    scheduled: { label: 'Scheduled', tone: 'info' },
    active: { label: 'Active', tone: 'success' },
    auto_locked: { label: 'Auto-locked', tone: 'danger' },
    no_show: { label: 'No-show', tone: 'danger' },
    pending_manager_review: { label: 'Needs review', tone: 'warning' },
    pending_reconciliation: { label: 'Pending reconciliation', tone: 'warning' },
    completed: { label: 'Completed', tone: 'neutral' },
    completed_with_discrepancy: { label: 'Completed with discrepancy', tone: 'warning' },
    cancelled: { label: 'Cancelled', tone: 'neutral' },
    suspended: { label: 'Suspended', tone: 'danger' },
});
export const deviceStatus = lookup({
    pending_approval: { label: 'Waiting for approval', tone: 'warning' },
    active: { label: 'Approved', tone: 'success' },
    approved: { label: 'Approved', tone: 'success' },
    temporarily_blocked: { label: 'Blocked', tone: 'danger' },
    blocked: { label: 'Blocked', tone: 'danger' },
});
export const accountStatus = lookup({
    active: { label: 'Active', tone: 'success' },
    suspended: { label: 'Suspended', tone: 'warning' },
    terminated: { label: 'Terminated', tone: 'danger' },
    banned: { label: 'Banned', tone: 'danger' },
});
export const withdrawalStatus = lookup({
    pending: { label: 'Pending', tone: 'warning' },
    processing: { label: 'Processing', tone: 'info' },
    approved: { label: 'Approved', tone: 'info' },
    awaiting_admin: { label: 'Awaiting review', tone: 'warning' },
    retry_scheduled: { label: 'Retry scheduled', tone: 'info' },
    completed: { label: 'Completed', tone: 'success' },
    failed: { label: 'Failed', tone: 'danger' },
    rejected: { label: 'Rejected', tone: 'danger' },
    cancelled: { label: 'Cancelled', tone: 'neutral' },
    expired: { label: 'Expired', tone: 'neutral' },
    partial: { label: 'Partial', tone: 'warning' },
    refunded: { label: 'Refunded', tone: 'neutral' },
});
export const ledgerStatus = lookup({
    completed: { label: 'Completed', tone: 'success' },
    pending: { label: 'Pending', tone: 'warning' },
    processing: { label: 'Processing', tone: 'info' },
    failed: { label: 'Failed', tone: 'danger' },
    cancelled: { label: 'Cancelled', tone: 'neutral' },
    pending_approval: { label: 'Pending approval', tone: 'warning' },
    rejected: { label: 'Rejected', tone: 'danger' },
});
export const cashierTxStatus = ledgerStatus;
